import { render, staticRenderFns } from "./ValuationSelector.vue?vue&type=template&id=8387f552"
import script from "./ValuationSelector.vue?vue&type=script&lang=js"
export * from "./ValuationSelector.vue?vue&type=script&lang=js"
import style0 from "./ValuationSelector.vue?vue&type=style&index=0&id=8387f552&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports